
import { Company } from "@/models/company";
import { CompanyModule } from "@/models/company-module";
import Vue, { VNode } from "vue";
import { CreateElement } from "vue/types/umd";
import AppExtraUsers from "./CompanyEditModuleMetaDataExtraUsers.vue";
import AppExtraDossiers from "./CompanyEditModuleMetaDataExtraDossiers.vue";
import AppMaxDocuments from "./CompanyEditModuleMetaDataMaxDocuments.vue";
import AppApiAccess from "./CompanyEditModuleMetaDataApiKeys.vue";
import AppOnlineBackup from "./CompanyEditModuleMetaDataOnlineBackup.vue";
import AppElectronischeFacturatie from "./CompanyEditModuleMetaDataElectronischeFacturatie.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>CompanyModule,
			required: true
		},
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	components: {
		AppExtraUsers,
		AppExtraDossiers,
		AppMaxDocuments,
		AppApiAccess,
		AppOnlineBackup,
		AppElectronischeFacturatie
	},
	render(createElement:CreateElement):VNode {
		return createElement(`app-${this.value.getEditMetaDataComponent()}`, {
			props: {
				value: this.value,
				company: this.company
			},
			on: {
				close: ()=>this.$emit("close"),
				saved: (value:CompanyModule)=>this.$emit("saved", value)
			}
		});
	}
});
